export default __webpack_public_path__ + "static/media/footer-icon-4.a647a5b8.svg";